import { render, staticRenderFns } from "./Integratedbusinessdevelopmentplatform.vue?vue&type=template&id=10ba9152&scoped=true"
import script from "./Integratedbusinessdevelopmentplatform.vue?vue&type=script&lang=js"
export * from "./Integratedbusinessdevelopmentplatform.vue?vue&type=script&lang=js"
import style0 from "./Integratedbusinessdevelopmentplatform.vue?vue&type=style&index=0&id=10ba9152&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ba9152",
  null
  
)

export default component.exports